import { render, staticRenderFns } from "./ActivityWsImage.vue?vue&type=template&id=c0e61aa6&scoped=true"
import script from "./ActivityWsImage.vue?vue&type=script&lang=ts"
export * from "./ActivityWsImage.vue?vue&type=script&lang=ts"
import style0 from "./ActivityWsImage.vue?vue&type=style&index=0&id=c0e61aa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0e61aa6",
  null
  
)

export default component.exports